import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {Button} from '../../basic-ui-components/button/base/button.component';
import {GameInfo} from '../../services/games/game-info';
import {GameItemComponentProps} from '../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/game-item.component-props';
import {GameItemContainerBox} from './boxes/game-item-container.box';
import {GameItemImgWrapperBox} from './boxes/game-item-img-wrapper.box';
import {GameItemFpThumbBox} from './boxes/game-item-fp-thumb.box';
// import { GameItemThumbnailBox } from './boxes/game-item-thumbnail.box';
import {GameItemDelimiterBox} from './boxes/game-item-delimiter.box';
import {GameItemDetailsWrapperBox} from './boxes/game-item-details-wrapper.box';
import {GameItemTitleBox} from './boxes/game-item-title.box';
import {GameItemJackpotBox} from './boxes/game-item-jackpot.box';
import {GameItemButtonsAreaBox} from './boxes/game-item-buttons-area.box';
import {GameImageComponent} from '../single-game/common/parts/game-image/game-image.component';
import {GameJackpotComponent} from "../game-jackpot/game-jackpot.component";

/**
 * This component (used for idle-recommendation toaster)
 * may have roughly the same functionality and/or visual
 * as game-popup.component.tsx
 * TODO: Maybe make a common component
 */
export class GameItemComponent extends OrbitComponent<GameItemComponentProps> {
    render() {
        let playBtnText = this.props.playBtnText || this.services.translation.translate('PLAY');
        let gameInfo: GameInfo = this.services.games.gamesMap[this.props.gameType];

        return (
            <GameItemContainerBox className={"cgp-game-item-container " + this.props.className} freePlayType={this.props.freePlayType} hide={this.props.hide} style={this.props.style}>
                <GameItemImgWrapperBox className="cgp-game-item-img-wrapper cgp-themes-icons-placeholder-game">
                    {/* <GameItemThumbnailBox
                    gameImagePath={gameInfo.getGameImage()}
                    className="cgp-game-item-thumbnail"
                /> */}
                    <GameImageComponent
                        gameInfo={gameInfo}
                    />
                    <GameItemFpThumbBox className="cgp-game-item-fp-thumb cgp-themes-icons-fp-default" freePlayType={this.props.freePlayType}></GameItemFpThumbBox>
                </GameItemImgWrapperBox>
                <GameItemDelimiterBox className="cgp-game-item-delimeter cgp-themes-property-icons-vertical-line-glow"></GameItemDelimiterBox>

                <GameItemDetailsWrapperBox className="cgp-game-item-details-wrapper">
                    <GameItemTitleBox className="cgp-game-item-title cgp-themes-main-text">{gameInfo.title}</GameItemTitleBox>
                    <GameItemJackpotBox className="cgp-game-item-jackpot-container">
                        <GameJackpotComponent gameType={this.props.gameType} />
                    </GameItemJackpotBox>
                    <GameItemButtonsAreaBox className="cgp-game-item-buttons-area">
                        <Button preset="primaryInverted" sizeVariant="small" onClick={this.props.onClickHandler}>{playBtnText}</Button>
                    </GameItemButtonsAreaBox>
                </GameItemDetailsWrapperBox>
            </GameItemContainerBox>
        )

    }
}
